import { Button, CircularProgress, Stack } from '@mui/material';
import { Check } from '@mui/icons-material';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ValidatorContext } from 'Validation/ValidatorContext';
import { INPUT_NAMES, INPUT_STEP_NAMES, INPUT_STEPS } from 'Pages/Inputs/constants';
import { useInputStore, useFetchingStore } from 'Store';

export const Submit = ({ setError }) => {
    const { getAllValidators } = useContext(ValidatorContext)
    const navigate = useNavigate()
    const [success, setSuccess] = useState(false)

    const postcode = useInputStore(state => state.postcode)
    const n_cows = useInputStore(state => state.n_cows)
    const milk_yield = useInputStore(state => state.milk_yield)
    const date_in = useInputStore(state => state.date_in)
    const date_out = useInputStore(state => state.date_out)
    const digest_energy = useInputStore(state => state.digest_energy)
    const lat = useInputStore(state => state.lat)
    const long = useInputStore(state => state.long)
    const sim_start_date = useInputStore(state => state.sim_start_date)
    const sim_end_date = useInputStore(state => state.sim_end_date)
    const date_empty = useInputStore(state => state.date_empty)

    const fetch = useFetchingStore(state => state.fetch)
    const fetching = useFetchingStore(state => state.fetching)

    const onSubmit = async () => {
        setSuccess(false)
    
        // Validate all steps before submitting
        const validation_result = getAllValidators()

        if (!validation_result.isValid) {
            const inputName = INPUT_NAMES[validation_result.input];
            const stepName = INPUT_STEPS[validation_result.step].name;
            if (validation_result.step === INPUT_STEP_NAMES.empty) {
                setError('Please fix errors before submitting')
            } else {
                // it should not be possible to have an error on a different input page 
                // as progressing is prevented if inputs are not valid - this is backup
                setError(`Please fix errors with the "${inputName}" input in the "${stepName}" step before submitting.`)
            }
            return
        } else {
            setError('')
        }
    
        const inputs = {
            postcode,
            lat: parseFloat(lat),
            long: parseFloat(long),
            n_cows,
            milk_yield,
            digest_energy,
            date_in,
            date_out,
            sim_start_date,
            sim_end_date,
            date_empty,
        };

        try {
            await fetch(inputs);
            setSuccess(true);
            setTimeout(() => navigate('/charts'), 1000);
        } catch (error) {
            console.error('Fetch failed:', error);
        }
    }

    const isBusy = fetching || success;

    return (
        <Stack spacing={2} alignItems='flex-start'>
            <Button
                color='success'
                variant='contained'
                size='large'
                onClick={onSubmit}
                sx={{
                    ...(isBusy && {
                        pointerEvents: 'none',
                        cursor: 'not-allowed',
                        '&:hover': {
                            backgroundColor: (theme) => theme.palette.success.main,
                        },
                    }),
                    // <CircularProgress/> needs padding to be same height as 'Submit' content
                    ...(fetching && {
                        padding: '11px',
                    }),
                    // <Check/> needs padding to be same height as 'Submit' content
                    ...(success && {
                        padding: '9px',
                    })
                }}
            >
                {fetching ? (
                    <CircularProgress size={20} color='inherit' />
                ) : success ? (
                    <Check />
                ) : (
                    'Submit'
                )}
            </Button>
        </Stack>
    );
};
